import { Product } from './Product'
import { Shipping } from './Shipping'

export class Order {
  constructor (object = {}) {
    if (object != null) {
      this.orderNr = object.orderNr
      this.date = this.formatDateTime(object.date)
      this.image = object.image
      this.grandTotal = this.formatPrice(object.grandTotal)
      this.coupon = object.coupon
      this.couponCode = object.couponCode !== 'COUPON_NOT_SENT' ? object.couponCode : undefined
      this.paymentMethod = object.paymentMethod
      this.store = object.store
      this.marketplace = object.marketplace
      this.itemsCount = object.itemsCount
      this.products = this.setProducts(object)
      this.shipping = this.setShipping(object)
      this.boleto = object.boleto
      this.covid = object.covid
      this.payments = object.payments
      this.invoice = object.invoice
    }
  }

  formatPrice (price) {
    if (price == null) {
      return null
    }
    return price.toString().replace('.', ',')
  }

  setProducts (object) {
    if (object.products == null) {
      return []
    }
    return object.products.map(element =>
      new Product(element)
    )
  }

  setShipping (object) {
    if (object.shipping == null) {
      return {}
    }
    return new Shipping(object.shipping)
  }

  formatDateTime (dateTime) {
    const dateTimeChunks = new Date(dateTime).toLocaleString('pt-BR', { hour12: false }).split(' ')
    const timeChunks = dateTimeChunks[1].split(':')
    timeChunks.splice(timeChunks.length - 1, 1)
    const date = dateTimeChunks[0]
    const time = timeChunks.join(':')
    const formatedDateTime = `${date} às ${time}`

    return formatedDateTime
  }
}
